var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-clickable',{staticClass:"selectable-button",class:( _obj = {}, _obj[_vm.color.toLowerCase()] = true, _obj.active = _vm.selected, _obj ),attrs:{"tag":"button"},on:{"click":function($event){return _vm.$emit('click', !_vm.selected)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }